import ReferralInstitutiont from "./ReferralInstitutiont";
export default ReferralInstitutiont;
